import { PageView } from '../../components/Analytics/PageView/PageView'
import { useEffect, useState,useMemo } from "react"
import ReactHtmlParser from 'react-html-parser'
import { TextAPI } from '../../api/TextAPI'
import Head from 'next/head';

const title = "TERMS AND CONDITIONS"
const textType = 'terms_conditions'

export default function TermsAndConditions() {

  const [ bodyText, setBodyText ] = useState("")

  const textAPI = useMemo(() => new TextAPI(process.env.NEXT_PUBLIC_API_BASE_URL ?? ''), [])

  useEffect(() => {
    textAPI.getByType(textType).then(text => text && setBodyText(text.body))
  }, [textAPI])

  return (
    <main>
      <Head key={'terms-conditons'}><title>Universal Orlando™ | Terms and Conditions</title></Head>
      <PageView
        pageName='Terms and Conditions'
      />
      <h1>{title}</h1>
      { ReactHtmlParser(bodyText) }
    </main>
  )
}
